import en_components from "./en/components.json";
import en_Seo from "./en/Seo.json";
import en_HomePage from "./en/HomePage.json";
import en_AboutPage from "./en/AboutPage.json";
import en_SciencePage from "./en/SciencePage.json";
import en_TeamPage from "./en/TeamPage.json";
import en_UpdatesPage from "./en/UpdatesPage.json";
import en_GetInvolvedPage from "./en/GetInvolvedPage.json";

import zh_components from "./zh/components.json";
import zh_Seo from "./zh/Seo.json";
import zh_HomePage from "./zh/HomePage.json";
import zh_AboutPage from "./zh/AboutPage.json";
import zh_SciencePage from "./zh/SciencePage.json";
import zh_TeamPage from "./zh/TeamPage.json";
import zh_UpdatesPage from "./zh/UpdatesPage.json";
import zh_GetInvolvedPage from "./zh/GetInvolvedPage.json";

import fr_components from "./fr/components.json";
import fr_Seo from "./fr/Seo.json";
import fr_HomePage from "./fr/HomePage.json";
import fr_AboutPage from "./fr/AboutPage.json";
import fr_SciencePage from "./fr/SciencePage.json";
import fr_TeamPage from "./fr/TeamPage.json";
import fr_UpdatesPage from "./fr/UpdatesPage.json";
import fr_GetInvolvedPage from "./fr/GetInvolvedPage.json";

export const RESOURCES = {
  en: {
    components: en_components,
    Seo: en_Seo,
    HomePage: en_HomePage,
    AboutPage: en_AboutPage,
    SciencePage: en_SciencePage,
    TeamPage: en_TeamPage,
    UpdatesPage: en_UpdatesPage,
    GetInvolvedPage: en_GetInvolvedPage,
  },
  zh: {
    components: zh_components,
    Seo: zh_Seo,
    HomePage: zh_HomePage,
    AboutPage: zh_AboutPage,
    SciencePage: zh_SciencePage,
    TeamPage: zh_TeamPage,
    UpdatesPage: zh_UpdatesPage,
    GetInvolvedPage: zh_GetInvolvedPage,
  },
  fr: {
    components: fr_components,
    Seo: fr_Seo,
    HomePage: fr_HomePage,
    AboutPage: fr_AboutPage,
    SciencePage: fr_SciencePage,
    TeamPage: fr_TeamPage,
    UpdatesPage: fr_UpdatesPage,
    GetInvolvedPage: fr_GetInvolvedPage,
  },
};

export const NAME_SPACES_MAP = {
  components: "components",
  Seo: "Seo",
  HomePage: "HomePage",
  AboutPage: "AboutPage",
  SciencePage: "SciencePage",
  TeamPage: "TeamPage",
  UpdatesPage: "UpdatesPage",
  GetInvolvedPage: "GetInvolvedPage",
} as const;

export const NAME_SPACES = Object.values(NAME_SPACES_MAP);
